<template>
<div id="sysScreenWrap">
  <div class="layoutIcon" v-if="isIcon">
    <slot name="icon"></slot>
  </div>
  <div class="layoutTitle" v-if="isTitle">
    <slot name=title></slot>
  </div>
  <div class="layoutDescription" v-if="isDescription">
    <slot name=description></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "instSystemScreenDescription",
  computed: {
    isIcon() {
      return this.$slots['icon'];
    },
    isTitle() {
      return this.$slots['title'];
    },
    isDescription(){
      return this.$slots['description'];
    }
  }
}
</script>

<style scoped>
#sysScreenWrap{min-height: 100vh;display: flex;flex-direction: column;align-items: center;justify-content: center}
.layoutIcon{width: var(--font-size-40);height: var(--font-size-40);position: relative;margin: 0 auto var(--font-size-16)}
.layoutTitle{font-size: var(--font-size-20);text-align: center;font-weight: 500;color:var(--color-dark-green);margin: 0 auto var(--font-size-16)}
.layoutDescription{font-size: var(--font-size-14);text-align: center;margin: 0 auto var(--font-size-16)}
</style>